import { router } from '@inertiajs/react';
import { twMerge } from 'tailwind-merge';
import { clsx } from 'clsx';

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export const getFirstLetter = (text) => {
    return (
        text
            .toUpperCase()
            .match(/\b(\w)/g)
            ?.join('')
            ?.slice(0, 2) ?? text[0]
    );
};

export function visitPartial(url, params) {
    const only = params.only || [];
    const paramsWithDot = only.filter((item) => item.includes('.'));

    if (paramsWithDot.length > 0) {
        // get only without dot
        params.only = only.filter((item) => !item.includes('.'));

        // get only first level of dotted items
        const additional = [...new Set(paramsWithDot.map((item) => item.split('.')[0]))];

        params.only = [
            ...params.only,
            ...additional,
            'flash',
            'errors',
            'info_popup',
            'csrf_token',
            'alerts',
        ];

        params.headers = {
            'X-Inertia-Partial-Data-Dot': paramsWithDot.join(','),
        };
    }

    router.visit(url, {
        ...params,
    });
}

export function debounce(func, ms) {
    let timeout;

    return function () {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, arguments), ms);
    };
}

export const GRId = (length = 5) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};

export function campaignAssetUrl(url) {
    return url.startsWith('data:image') ||
        url.startsWith('http://') ||
        url.startsWith('https://')
        ? url
        : url.startsWith('/storage')
          ? `${import.meta.env.VITE_CDN_URL}${url.replace('/storage', '')}`
          : `${import.meta.env.VITE_CDN_URL}${url}`;
}

export function assetUrl(url) {
    return url.startsWith('http://') ||
        url.startsWith('https://') ||
        !import.meta.env.VITE_ASSET_URL
        ? url
        : `${import.meta.env.VITE_ASSET_URL}/${url.replace(/^\//, '')}`;
}

export const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
            resolve(fileReader.result);
        };
        fileReader.onerror = (error) => {
            reject(error);
        };
    });
};

export const sentryBeforeSend = (event, hint) => {
    if (import.meta.env.VITE_SENTRY_ENVIRONMENT === 'local') {
        console.error('Sentry error', { event, hint });
        return null; // Disable sending events to Sentry
    }

    // Example: exclude ResizeObserver loop errors
    /*if (
        hint?.originalException instanceof Error &&
        hint.originalException.message.includes('ResizeObserver loop limit exceeded')
    ) {
        return null;
    }*/

    // Example: exclude some known error messages
    const ignoredMessages = [
        "Cannot read properties of null (reading 'scrollRegions')",
        'Failed to fetch',
        "Cannot read properties of null (reading 'page')",
        "null is not an object (evaluating 'window.history.state.scrollRegions')",
        'Non-Error promise rejection captured with value: Timeout',
        "Failed to execute 'insertBefore' on 'Node'",
        "Cannot read properties of undefined (reading 'version')",
        'Network Error',
    ];

    if (
        event?.exception?.values?.[0]?.value &&
        ignoredMessages.some((msg) => event.exception.values[0].value.includes(msg))
    ) {
        return null;
    }

    return event; // send everything else
};
